<template>
  <div>
    <v-row class="fill-height">
      <v-col cols="2">
        <router-link :to="{ name: 'Factura' }">
          <v-btn color="white--text cyan lighten-1" class="mx-2 my-2">+ Factura</v-btn>
        </router-link>
      </v-col>
      <v-col>
        <v-text-field v-model="search" prepend-icon="search" label="Cauta produs dupa nume, strada sau adresa"
          placeholder="Cautare..." single-line>
        </v-text-field>
      </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="listDocuments" class="elevation-1">
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="download(item)" v-bind="attrs" v-on="on">
              get_app
            </v-icon>
          </template>
          <span>Descarca</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="sendEmail(item)" v-bind="attrs" v-on="on">
              send
            </v-icon>
          </template>
          <span>Trimite email</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="syncEInvoice(item)" v-bind="attrs" v-on="on">
              sync
            </v-icon>
          </template>
          <span>Sincronizare efactura</span>
        </v-tooltip>
        <v-tooltip v-if="item.type === 'invoice' || item.type === 'invoice-reps'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoInvoice(item.invoice.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare factura</span>
        </v-tooltip>
        <v-icon @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'ListDocuments',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Numar',
          align: 'center',
          value: 'number',
          sortable: true,
        },
        {
          text: 'Tip',
          align: 'center',
          value: 'typeName',
          sortable: true,
        },
        {
          text: 'Document',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Nume Client',
          align: 'center',
          value: 'invoice.name',
          sortable: true,
        },
        {
          text: 'Strada',
          align: 'center',
          value: 'invoice.street',
          sortable: true,
        },
        {
          text: 'Adresa',
          align: 'center',
          value: 'invoice.addressDetails',
          sortable: true,
        },

        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
      search: '',
    };
  },
  created() {
    this.getCustomDocuments();
  },
  watch: {
    async search(query) {
      this.searchDocument(query);
    },
  },
  computed: {
    listDocuments() {
      return this.$store.state.documents.all.map(el => {
        el.typeName = this.formatDocumentType(el.type)
        return el
      })
    },
  },
  methods: {
    ...mapActions('documents', ['getCustomDocuments', 'searchDocument']),

    async download(item) {
      const response = await this.$store.dispatch('documents/downloadCustom', {
        documentId: item.id,
      });

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const fileName =
        response.headers['content-disposition'].match("filename='(.*)'");
      fileLink.setAttribute('download', fileName[1]);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    },
    sendEmail(item) {
      this.$store.dispatch('documents/sendEmailCustom', {
        documentId: item.id,
        type: item.type,
      });
    },
    syncEInvoice(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('documents/syncEInvoice', item.invoice.id);
      }
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('documents/deleteCustom', {
          documentId: item.id,
        });
      }
    },

    gotoInvoice(id) {
      this.$router.push({
        name: 'Editare Factura Servicii',
        params: { id },
      });
    },

    formatDocumentType(type) {
      switch (type) {
        case 'invoice':
          return 'Factura'

        case 'invoice-reps':
          return 'Factura REPS'

        case 'livret':
          return 'Autorizatie'

        case 'contract':
          return 'Contract'

        case 'worksheet':
          return 'Fisa Lucrari'

        case 'report':
          return 'Proces Verbal'

        case 'pv-iugn-srb':
          return 'Proces Verbal IUGN'

        default:
          return 'Document necunoscut'
      }
    },

  },
};
</script>

<style scoped>
.color-default a {
  color: white;
  text-decoration: none;
}
</style>
